import { render, staticRenderFns } from "./change-approval.vue?vue&type=template&id=6ad3eaf4&scoped=true"
import script from "./change-approval.vue?vue&type=script&lang=js"
export * from "./change-approval.vue?vue&type=script&lang=js"
import style0 from "./change-approval.vue?vue&type=style&index=0&id=6ad3eaf4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad3eaf4",
  null
  
)

export default component.exports